module.exports = __webpack_public_path__ + "static/billy-c964c154e777826b033710b7b3617d38.png";